let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7tgIc")).then(() => parcelRequire('bQdir'));